import styled from 'styled-components';

export const LandPageAppWrapper = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh; /* Ensure it takes the full height of the viewport */
  background-image: url('/images/landpage2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;